module.exports = __webpack_public_path__ + "static/media/column.13fe758c.jpg";